import { TextField } from '../../atoms';
import { FORM_CLASSIFIERS_GO_AUTO_EDIT } from '../../constants/formKeys';
import {
  getClassifiersGoAutoChange,
  getClassifiersGoAutoItem,
  getClassifiersGoAutoItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { goAutomaticCancel } from '../../constants/parameters';
import createParameterEditor from '../createParameterEditor';

export default createParameterEditor({
  title: 'parameterGoAutoTitle',
  formKey: FORM_CLASSIFIERS_GO_AUTO_EDIT,
  fields: [
    {
      name: goAutomaticCancel.VALUE,
      label: 'fieldGoAuto',
      component: TextField,
      className: 'date-field',
    },
  ],
  fetchAction: actions.fetchClassifierGoAuto,
  changeAction: actions.changeClassifierGoAuto,
  getChangeSelector: getClassifiersGoAutoChange,
  getItemSelector: getClassifiersGoAutoItem,
  getInitialValues: (state) => ({
    [goAutomaticCancel.VALUE]: getClassifiersGoAutoItemData(state),
  }),
});
